const usCurrencyFormatterRounded = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
})

export function formatToRoundedDollar(
    value: string | number | null | undefined,
) {
    if (value === null || value === undefined) {
        return ''
    }

    const rawCurrency = value.toString().trim()

    if (!rawCurrency) {
        return ''
    }

    const number = Number(rawCurrency)

    if (isNaN(number)) {
        return ''
    }

    return usCurrencyFormatterRounded.format(number)
}
